import { ToastrService } from 'ngx-toastr';

import { Component, OnInit, Inject } from '@angular/core';

import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/compat/firestore';
import { Observable, Subscription } from 'rxjs';

import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";

import { SelectLanguagesDialogComponent } from './select-languages-dialog/select-languages-dialog.component';

import { SpinnerService } from '../../services/spinner.service';
import { ConfigurationService } from '../../configuration.service';
import { ApiClientService } from '../../api-client.service';
import { AppConst } from '../../app-const';
import { ApiProject } from '../../api-client-module';
import { ApiProjectLanguage } from '../../api-client-module';
import { ApiVoiceCode } from '../../api-client-module';
import { Language } from '../../firestore-models/language';
import { ApiSetProjectsRequest } from '../../api-client-module';
import { TranslateService } from '@ngx-translate/core';
import { lastValueFrom } from 'rxjs';

export interface TopDialogData {
  change_type: number;
  project?: ApiProject;
  adminUser: boolean;
}

@Component({
  selector: 'app-top-dialog',
  templateUrl: './top-dialog.component.html',
  styleUrls: ['./top-dialog.component.css'],
  standalone: false,
})
export class TopDialogComponent implements OnInit {

  //各プロジェクトß
  project?: ApiProject;
  //追加フラグ
  isAdded: boolean = false;
  //選択された言語
  selectedTtsVoiceDict: { [key: string]: ApiVoiceCode } = {};

  adminUser!: boolean;
  // ユーザータイプ
  readonly USER_TYPE_ADMIN: number = AppConst.MANAGE_USER_TYPE_ADMIN;
  readonly USER_TYPE_MASTER: number = AppConst.MANAGE_USER_TYPE_MASTER;
  userType!: number;

  keypadTypes = AppConst.KEYPAD_TYPES;
  transBaseLangs = AppConst.TRANS_BASE_LANGS;
  projectBaseLangs = AppConst.TRANS_BASE_LANGS;

  //プロジェクト情報のフォーム
  projectFormGroup!: FormGroup;
  projectIdControl!: FormControl;
  projectNameControl!: FormControl;
  projectDescControl!: FormControl;
  keypadTypeControl!: FormControl;
  projectBaseLangControl!: FormControl;
  transBaseLangControl!: FormControl;
  useTransBaseLangKoControl!: FormControl;
  useTransBaseLangYueHKControl!: FormControl;
  useTransBaseLangZhCNControl!: FormControl;
  useTransBaseLangZhTWControl!: FormControl;
  facilityRegistrationLimitControl!: FormControl;
  languages: Array<Language> = [];

  private languagesCollection!: AngularFirestoreCollection<Language>;
  languagesObservable!: Observable<Language[]>;
  languagesSubscribe!: Subscription;
  allLanguages: Array<Language> = [];

  currentLang: string = 'ja';

  constructor(
    private configurationService: ConfigurationService,
    public dialogRef: MatDialogRef<TopDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TopDialogData,
    private formBuilder: FormBuilder,
    private angularFirestore: AngularFirestore,
    public dialog: MatDialog,
    private translate: TranslateService,
    private apiClientService: ApiClientService,
    private spinnerService: SpinnerService,
    private toastr: ToastrService,
  ) {
    this.userType = this.configurationService.getUserType();
  }

  ngOnInit(): void {
    this.adminUser = this.data.adminUser;
    this.project = this.data.project
    this.currentLang = this.translate.currentLang;
    //管理画面の援護モードによって言語選択肢を変更 #216
    this.projectBaseLangs = [
      AppConst.TRANS_BASE_LANG_JA,
      AppConst.TRANS_BASE_LANG_EN,
      AppConst.TRANS_BASE_LANG_US
    ];
    if (!this.project) {
      this.project = {
        project_id: '',
        project_name: '',
        project_app_names: [],
        project_desc: '',
        latitude: AppConst.LATITUDE_INITIAL_VALUE,
        longitude: AppConst.LONGITUDE_INITIAL_VALUE,
        languages: [],
        enabled: true,
        maintenance_flag: false,
        facility_registration_limit: 1,
        keypad_type: AppConst.KEYPAD_TYPE_TEL,
        trans_base_lang: AppConst.TRANS_BASE_LANG_EN,
        project_base_lang:AppConst.TRANS_BASE_LANG_JA,
        use_trans_base_lang_ko: false,
        use_trans_base_lang_yuehk: false,
        use_trans_base_lang_zhcn: false,
        use_trans_base_lang_zhtw: false,
      };
      this.isAdded = true;
    }
    for (const language of this.project.languages!) {
      this.selectedTtsVoiceDict[language.lang_code] = language.tts_voice_code;
    }
    this.createForm();
    this.projectIdControl = this.projectFormGroup.get('projectId') as FormControl;
    this.projectNameControl = this.projectFormGroup.get('projectName') as FormControl;
    this.projectDescControl = this.projectFormGroup.get('projectDesc') as FormControl;
    this.keypadTypeControl = this.projectFormGroup.get('keypadType') as FormControl;
    this.projectBaseLangControl = this.projectFormGroup.get('projectBaseLang') as FormControl;
    this.transBaseLangControl = this.projectFormGroup.get('transBaseLang') as FormControl;
    this.useTransBaseLangKoControl = this.projectFormGroup.get('useTransBaseLangKo') as FormControl;
    this.useTransBaseLangYueHKControl = this.projectFormGroup.get('useTransBaseLangYueHK') as FormControl;
    this.useTransBaseLangZhCNControl = this.projectFormGroup.get('useTransBaseLangZhCN') as FormControl;
    this.useTransBaseLangZhTWControl = this.projectFormGroup.get('useTransBaseLangZhTW') as FormControl;
    this.facilityRegistrationLimitControl = this.projectFormGroup.get('facilityRegistrationLimit') as FormControl;

    this.languagesCollection = this.angularFirestore.collection<Language>('languages');
    this.languagesObservable = this.languagesCollection.valueChanges({ idField: 'id' });
    this.languagesSubscribe = this.languagesObservable.subscribe(languages => {
      this.allLanguages = [];
      for (const language of languages) {
        this.allLanguages.push(language)
      }
    }
  );

    this.getLanguages();

    // 新規登録時のみプロジェクト基本言語の編集を有効にする)
    !this.isAdded ? this.projectBaseLangControl.disable() : this.projectBaseLangControl.enable();
  }

  //以下、フォームのエラー表
  require_str: string = this.translate.instant('必須項目');
  half_numeric_str: string = this.translate.instant('半角数字記号');
  public getErrorMessageToProjectId() {

    return this.projectIdControl.hasError('required')
      ? this.require_str
      : this.projectIdControl.hasError('pattern')
        ? this.half_numeric_str
        : '';
  }

  public getErrorMessageToProjectName() {
    return this.projectNameControl.hasError('required')
      ? this.require_str
      : '';
  }

  public getErrorMessageToFacilityRegistrationLimit() {
    return this.facilityRegistrationLimitControl.hasError('required')
      ? this.require_str
      : '';
  }

  public getErrorMessageToKeypadType() {
    return this.keypadTypeControl.hasError('required')
      ? this.require_str
      : '';
  }

  public getErrorMessageToTransBaseLang() {
    return this.keypadTypeControl.hasError('required')
      ? this.require_str
      : '';
  }

  public getErrorMessageToProjectBaseLang() {
    return this.keypadTypeControl.hasError('required')
      ? this.require_str
      : '';
  }

  //フォームの値を各要素に代入
  private createForm() {
    this.projectFormGroup = this.formBuilder.group(
      {
        projectId: [this.project!.project_id, [Validators.required, Validators.pattern('^[a-zA-Z0-9!-/:-@¥[-`{-~]*$')]],
        projectName: [this.project!.project_name, [Validators.required]],
        projectDesc: [this.project!.project_desc],
        facilityRegistrationLimit: [this.project!.facility_registration_limit ? this.project!.facility_registration_limit : 1, [Validators.required]],
        keypadType: [this.project!.keypad_type ? this.project!.keypad_type : AppConst.KEYPAD_TYPE_TEL, [Validators.required]],
        transBaseLang: [this.project!.trans_base_lang ? this.project!.trans_base_lang : AppConst.TRANS_BASE_LANG_EN, [Validators.required]],
        projectBaseLang: [this.project!.project_base_lang ? this.project!.project_base_lang : AppConst.TRANS_BASE_LANG_EN, [Validators.required]],
        useTransBaseLangKo: [this.project!.use_trans_base_lang_ko ? this.project!.use_trans_base_lang_ko : false],
        useTransBaseLangYueHK: [this.project!.use_trans_base_lang_yuehk ? this.project!.use_trans_base_lang_yuehk : false],
        useTransBaseLangZhCN: [this.project!.use_trans_base_lang_zhcn ? this.project!.use_trans_base_lang_zhcn : false],
        useTransBaseLangZhTW: [this.project!.use_trans_base_lang_zhtw ? this.project!.use_trans_base_lang_zhtw : false],
      }
    );
  }

  //言語選択
  private getLanguages() {
    this.languages = [];
    if (!!this.project!.languages && this.project!.languages.length > 0) {
      const langCodes: Array<string> = this.project!.languages.map(item => {
        return item.lang_code;
      });
      this.angularFirestore.collection<Language>(
        'languages', ref => ref.orderBy('lang_code', 'asc')
      ).valueChanges({ idField: 'id' }).subscribe(docs => {
        this.languages = [];
        if (!!docs) {
          for (const projectBaseLanguage of this.project!.languages!) {
            for (const language of docs) {
              if (projectBaseLanguage.lang_code === language.id) {
                this.languages.push(language);
                break;
              }
            }
          }
        }
      });
    }
  }

  //更新ボタン
  async addProject(): Promise<void> {
    if (this.projectFormGroup.valid && !!this.languages.length) {
      this.project!.project_id = this.projectIdControl.value;
      this.project!.project_name = this.projectNameControl.value;
      this.project!.project_desc = this.projectDescControl.value;
      this.project!.facility_registration_limit = this.facilityRegistrationLimitControl.value;

      let languages: Array<ApiProjectLanguage> = [];
      for (const language of this.languages) {
        // 英語の言語名を設定
        const currentLang = this.translate.currentLang;
        await lastValueFrom(this.translate.use('en'));
        language.lang_name_en = await lastValueFrom(this.translate.get(language.lang_name));
        await lastValueFrom(this.translate.use(currentLang));
        languages.push({
          lang_code: language.lang_code,
          lang_name: language.lang_name,
          lang_name_en: language.lang_name_en,
          display_name: language.display_name,
          trans_lang_code: language.trans_lang_code,
          tts_lang_code: language.tts_lang_code,
          tts_voice_code: this.selectedTtsVoiceDict[language.lang_code]
        });
      }
      this.project!.languages = languages;
      this.project!.keypad_type = this.keypadTypeControl.value;
      this.project!.trans_base_lang = this.transBaseLangControl.value;
      this.project!.project_base_lang = this.projectBaseLangControl.value;
      this.project!.use_trans_base_lang_ko = this.useTransBaseLangKoControl.value;
      this.project!.use_trans_base_lang_yuehk = this.useTransBaseLangYueHKControl.value;
      this.project!.use_trans_base_lang_zhcn = this.useTransBaseLangZhCNControl.value;
      this.project!.use_trans_base_lang_zhtw = this.useTransBaseLangZhTWControl.value;
      if (this.project) {
        let request: ApiSetProjectsRequest = {
          access_token: '',
          change_type: this.data.change_type,
          projects: [this.project]
        }
        this.spinnerService.openSpinner();
        this.apiClientService.setProjects(request).then(
          response => {
            if (response!.ret === AppConst.API_RET_SUCCESS) {
              this.toastr.success(this.translate.instant('登録しました。'));
              this.dialogRef.close();
            } else if (response!.ret === AppConst.API_RET_ALREADY_EXIST_DATA) {
              this.toastr.error(this.translate.instant('既に同じIDが登録済みです。'), '', { timeOut : 5000 });
            } else {
              console.error('api update error. ret='+response!.ret);
              this.toastr.error(this.translate.instant('登録できませんでした。'), '', { timeOut : 5000 });
            }
          }
        ).catch(
          error => {
            console.log(error);
            this.translate.get('登録できませんでした。').subscribe((res: string) => {
              this.toastr.success(res);
            });
          }
        ).finally(
          () => {
            this.spinnerService.closeSpinner();
          }
        );
      }
    }
  }

  //話者性別選択
  getSelectedTtsVoice(langCode: string): string {
    let ttsVoiceCode: string = '';
    let ttsVoice: ApiVoiceCode = this.selectedTtsVoiceDict[langCode];
    if (!!ttsVoice) {
      for (const language of this.languages) {
        if (language.lang_code === langCode) {
          for (const voice of language.tts_voice_codes) {
            if (voice.code !== '' && voice.code === ttsVoice.code) {
              ttsVoiceCode = voice.code;
              break;
            }
          }
        }
      }
    }
    if (!ttsVoiceCode) {
      for (const language of this.languages) {
        if (language.lang_code === langCode) {
          if (language.tts_voice_codes[0].code !== '') {
            ttsVoiceCode = language.tts_voice_codes[0].code;
            this.selectedTtsVoiceDict[langCode] = language.tts_voice_codes[0];
          } else {
            ttsVoiceCode = language.tts_voice_codes[1].code;
            this.selectedTtsVoiceDict[langCode] = language.tts_voice_codes[1];
          }
          break;
        }
      }
    }
    return ttsVoiceCode;
  }

  //変更された話者を登録
  changeSelectedTtsVoice(langCode: string, event: any) {
    for (const language of this.languages) {
      if (language.lang_code === langCode) {
        for (const voice of language.tts_voice_codes) {
          if (voice.code === event.value) {
            this.selectedTtsVoiceDict[langCode] = voice;
            break;
          }
        }
      }
    }
  }

  //言語選択ダイアログ
  openSelectLanguagesDialog(): void {
    const dialogRef = this.dialog.open(SelectLanguagesDialogComponent, {
      width: '80%',
      height: '90%',
      disableClose: true,
      data: { language: null }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result && result.length > 0) {
        let isChanged: boolean = false;
        if (!this.project!.languages || !this.project!.languages.length) {
          this.project!.languages = result;
          isChanged = true;
        } else {
          for (const row of result) {
            let isAdded: boolean = true;
            for (const language of this.project!.languages) {
              if (language.lang_code === row.id) {
                isAdded = false;
                break;
              }
            }
            if (!!isAdded) {
              this.project!.languages.push(row);
              isChanged = true;
            }
          }
        }
        if (!!isChanged) {
          this.changeLanguage();
        }
      }
    });
  }

  changeProjectBaseLanguage(): void {
    const baseLang = this.projectBaseLangControl.value;
    this.project!.project_base_lang = baseLang;
    this.project!.project_base_lang = this.getSelectProjectBaseLang();
    if (baseLang !== 'ja') {
      this.transBaseLangControl.setValue(baseLang);
    }
  }

  changeLanguage(): void {
    let isJa: boolean = false;
    let isEn: boolean = false;
    let isOther: boolean = false;
    if (!this.project!.languages || !this.project!.languages.length) {
    } else {
      for (const language of this.project!.languages) {
        if (language.lang_code === 'ja') {
          isJa = true;
        }
        if (language.lang_code === this.getSelectTransBaseLang()) {
          isEn = true;
        }
        if (language.lang_code !== 'ja' && language.lang_code !== this.getSelectTransBaseLang()) {
          isOther = true;
        }
      }
      if (!isJa) {
        for (const allLanguage of this.allLanguages) {
          if (allLanguage.lang_code == 'ja') {
            const apiLanguage: ApiProjectLanguage = {
              lang_code: allLanguage.lang_code,
              lang_name: allLanguage.lang_name,
              lang_name_en: allLanguage.lang_name_en,
              display_name: allLanguage.display_name,
              trans_lang_code: allLanguage.trans_lang_code,
              tts_lang_code: allLanguage.tts_lang_code,
              tts_voice_code: this.selectedTtsVoiceDict[allLanguage.lang_code]
            };
            this.project!.languages.push(apiLanguage);
          }
        }
      }
      if (isOther && !isEn) {
        for (const allLanguage of this.allLanguages) {
          if (allLanguage.lang_code == this.getSelectTransBaseLang()) {
            const apiLanguage: ApiProjectLanguage = {
              lang_code: allLanguage.lang_code,
              lang_name: allLanguage.lang_name,
              lang_name_en: allLanguage.lang_name_en,
              display_name: allLanguage.display_name,
              trans_lang_code: allLanguage.trans_lang_code,
              tts_lang_code: allLanguage.tts_lang_code,
              tts_voice_code: this.selectedTtsVoiceDict[allLanguage.lang_code]
            };
            this.project!.languages.push(apiLanguage);
          }
        }
      }
    }
    this.getLanguages();
  }

  //選択した言語を削除
  deleteLanguage(id: string): void {
    const filterLanguages = this.project!.languages!.filter(value => value.lang_code !== id);
    if (filterLanguages.length !== this.project!.languages!.length) {
      this.project!.languages = filterLanguages;
      this.getLanguages();
    }
  }

  //言語並べ替え
  onDropLanguage(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.languages, event.previousIndex, event.currentIndex);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
  changeProjectBaseLang(): void {
    this.changeProjectBaseLanguage();
  }
  changeTransBaseLang(): void {
    this.changeLanguage();
  }

  getSelectProjectBaseLang(): string {
    return this.projectBaseLangControl.value ? this.projectBaseLangControl.value : AppConst.TRANS_BASE_LANG_EN;
  }

  getSelectTransBaseLang(): string {
    return this.transBaseLangControl.value ? this.transBaseLangControl.value : AppConst.TRANS_BASE_LANG_EN;
  }

}
